import * as React from "react";
import type { SVGProps } from "react";
const PlayPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 20a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m-.703-11.413a.5.5 0 0 0-.797.402v5.022a.5.5 0 0 0 .797.402l3.407-2.51a.5.5 0 0 0 0-.806z" clipRule="evenodd" /></svg>;
export default PlayPanelIcon;